module.exports = __webpack_public_path__ + "static/img/function-box-img4.947ba7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedPortal/function-box-img4.png
// module id = IcTX
// module chunks = 0